import type { ComponentPropsWithoutRef } from "react";

import { tw } from "@/shared/utils";
import { Skeleton as SkeletonPrimitive } from "../common";

type CheckableCardsSkeletonProps = ComponentPropsWithoutRef<"div"> & {
  count?: number;
};

export const CheckableCardsSkeleton = ({
  className,
  count = 3,
  ...props
}: CheckableCardsSkeletonProps) => {
  return (
    <div className={tw("grid gap-2", className)} {...props}>
      {Array.from({ length: count }, (_, index) => `${index}`).map((i) => (
        <div
          key={`radio-group-skeleton-${i}`}
          className="flex flex-col gap-2 rounded-lg border border-secondary-100 bg-secondary-50 p-3"
        >
          <div className="flex items-center gap-2">
            <SkeletonPrimitive className="size-5" />
            <SkeletonPrimitive className="h-4 w-2/5" />
          </div>

          <SkeletonPrimitive className="ml-7 h-3 w-3/5" />
        </div>
      ))}
    </div>
  );
};
